import { classNamesFunction, CommandBarButton, FontSizes, Stack, styled, Theme } from '@fluentui/react';
import { RootState } from 'app/store';
import logo from 'assets/bcbssc-logo-white.svg';
import { Constants } from 'global/Application/Constants';
import { useDispatch, useSelector } from 'react-redux';
import Search from './Search';
import { UserMenu } from './UserMenu';
import { CSSProperties } from 'react';

interface IMenuProp {
  theme?: Theme
  styles?: any
}
const getStyles = ({ theme }: IMenuProp) => {
  const styleMapping = {
    "System": theme?.palette.redDark,
    "Development": theme?.palette.greenDark,
    "Production": theme?.palette.themePrimary,
  }
  return {
    root: {
      borderBottomStyle: 'solid',
      borderBottomColor: theme?.semanticColors.bodyFrameDivider,
      borderBottomWidth: 1,
      padding: theme?.spacing.s1,
      backgroundColor: styleMapping[Constants.env] ?? theme?.palette.themePrimary,
      height: 'auto',
      borderRadius: '0px',
    }
  };
};


const getClassNames = classNamesFunction();

function TopMenuComponent({ styles, theme }: IMenuProp) {
  const store = useSelector((state: RootState) => state);
  const dispatch = useDispatch();

  const isEditor = store.router.location.pathname.startsWith('/records/blueRelationship/');

  const classNames: any = getClassNames(styles, { theme });
  return (
    <>
      <Stack
        horizontal
        horizontalAlign="space-between"
        verticalAlign='center'
        className={classNames.root}
        tokens={{ childrenGap: '1em' }}>
        <div>
          <img alt={"logo"} src={logo} style={{ width: '48px', paddingRight: '20px' }} />
          <span style={{ fontSize: FontSizes.size16, color: 'white', paddingRight: '20px' }}>|</span>
          <span style={{ fontSize: FontSizes.size16, color: 'white' }} >Group Library</span>
        </div>

        {isEditor &&
          <Search />
        }

        <Stack horizontal>

          {/* <CommandBarButton
            styles={{
              root: { backgroundColor: 'transparent', margin: '0px' },
              rootHovered: { backgroundColor: 'transparent' },
              rootChecked: { backgroundColor: 'white' }
            }}
            iconProps={{ iconName: 'Search', styles: { root: { color: 'white', fontSize: '24px' } } }}
            disabled={false}
            checked={false}
          /> */}

          {/* <CommandBarButton
            styles={{
              root: { backgroundColor: 'transparent', margin: '0px' },
              rootHovered: { backgroundColor: 'transparent' },
              rootChecked: { backgroundColor: 'white' }
            }}
            iconProps={{ iconName: 'Ringer', styles: { root: { color: 'white', fontSize: '24px' } } }}
            disabled={false}
            checked={false}
          /> */}

          <UserMenu />
        </Stack>
      </Stack>
    </>
  );
}

export const TopMenu = styled(TopMenuComponent, getStyles);
